// import React from 'react'
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { comma, removeComma } from '../../service/project'

// function Project_contract({ handleChanges, onClickss, onClick, contract, specificationImgRef, savePdfFile, userId }) {
function Project_contract({
    handleChanges,
    onClickss,
    onClick,
    contract,
    specificationImgRef,
    savePdfFile,
    userId,
    offerlist,
}) {
    const BEFORE_TERM = '계약 후 3일 이내'
    const MIDDLE_TERM = '1단계 개발 완료 후 3일 이내'
    const AFTER_TERM = '최종 납품 후 3일 이내'

    const DEFAULT_BANK_NAME = 'KB국민은행'
    const DEFAULT_BANK_OWNER = '박진영(니즈로봇)'
    const DEFAULT_BANK_ACCOUNT = '759901-00-065816'

    useEffect(
        function () {
            if (!contract) return

            if (!contract.beforepricecon) {
                handleChanges('beforepricecon', BEFORE_TERM)
            }

            if (!contract.middlepricecon) {
                handleChanges('middlepricecon', MIDDLE_TERM)
            }

            if (!contract.afterpricecon) {
                handleChanges('afterpricecon', AFTER_TERM)
            }

            if (!contract.bankname) {
                handleChanges('bankname', DEFAULT_BANK_NAME)
            }

            if (!contract.bankowner) {
                handleChanges('bankowner', DEFAULT_BANK_OWNER)
            }

            if (!contract.bankaccount) {
                handleChanges('bankaccount', DEFAULT_BANK_ACCOUNT)
            }

            var latestOffer = Array.isArray(offerlist) && offerlist.length > 0 ? offerlist[offerlist.length - 1] : null

            if (!contract.allprice && latestOffer && latestOffer.price) {
                handleChanges('allprice', latestOffer.price)
            }
        },
        [
            contract && contract.uid,
            contract && contract.beforepricecon,
            contract && contract.middlepricecon,
            contract && contract.afterpricecon,
            contract && contract.allprice,
            offerlist,
        ],
    )
    const getPercent = (key) => {
        return Number((contract && contract[key]) || 0)
    }

    const getLatestOfferPrice = () => {
        var latestOffer = Array.isArray(offerlist) && offerlist.length > 0 ? offerlist[offerlist.length - 1] : null

        return latestOffer && latestOffer.price ? latestOffer.price : ''
    }

    const setDefaultPrice = () => {
        var price = getLatestOfferPrice()

        if (price) {
            handleChanges('allprice', price)
        }
    }

    const setDefaultBank = () => {
        handleChanges('bankname', DEFAULT_BANK_NAME)
        handleChanges('bankowner', DEFAULT_BANK_OWNER)
        handleChanges('bankaccount', DEFAULT_BANK_ACCOUNT)
    }

    const handlePercentChange = (key, value) => {
        let next = Number(value)

        if (value === '') {
            handleChanges(key, '')
            return
        }

        if (Number.isNaN(next)) {
            next = 0
        }

        if (next < 0) {
            next = 0
        }

        if (next > 100) {
            next = 100
        }

        const otherTotal =
            (key === 'beforeprice' ? 0 : getPercent('beforeprice')) +
            (key === 'middleprice' ? 0 : getPercent('middleprice')) +
            (key === 'afterprice' ? 0 : getPercent('afterprice'))

        if (otherTotal + next > 100) {
            next = 100 - otherTotal
        }

        if (next < 0) {
            next = 0
        }

        handleChanges(key, String(next))
    }

    return (
        <div className="w100">
            <div className="input_wrap mb10">
                <h1 className="mb10 flex minititle a mt20">
                    1.프로젝트 계약서 명칭
                    <p className="subtext ml10">프로젝트 계약의 목적과 내용을 반영하는 명칭으로 지정할것</p>
                </h1>

                <input
                    defaultValue={contract && contract.title}
                    onChange={(e) => handleChanges('title', e.target.value)}
                    className="projectAdd_inputbox"
                />
            </div>

            <div className="flex j a w100 mb10">
                <div className="input_wrap w33">
                    <h1 className="mb10 flex minititle a">
                        2.계약 시작일
                        <p className="subtext ml10">실제 계약일자</p>
                    </h1>
                    <input
                        type="date"
                        defaultValue={contract && contract.startdate}
                        onChange={(e) => handleChanges('startdate', e.target.value)}
                        className="projectAdd_inputbox"
                    />
                </div>

                <div className="input_wrap w33">
                    <h1 className="mb10 flex minititle a">
                        3.계약 마감일
                        <p className="subtext ml10">프로젝트 완료예정 일자</p>
                    </h1>
                    <input
                        type="date"
                        defaultValue={contract && contract.lastdate}
                        onChange={(e) => handleChanges('lastdate', e.target.value)}
                        className="projectAdd_inputbox"
                    />
                </div>

                <div className="input_wrap w33">
                    <h1 className="mb10 flex minititle a">
                        4.납품 장소
                        <p className="subtext ml10"></p>
                    </h1>
                    <input
                        defaultValue={contract && contract.deliverylocation}
                        onChange={(e) => handleChanges('deliverylocation', e.target.value)}
                        className="projectAdd_inputbox"
                    />
                </div>
            </div>

            <div className="input_wrap mb10">
                <h1 className="mb10 flex minititle a">
                    5.계약내용
                    <p className="subtext ml10">시제품 설계 및 제작, 펌웨어, 개발자료, 제공방법 등 간략하게 기재</p>
                </h1>
                <textarea
                    defaultValue={contract && contract.detail}
                    rows="3"
                    value={contract && contract.detail}
                    onChange={(e) => handleChanges('detail', e.target.value)}
                    className="projectAdd_inputbox"
                    placeholder=" ex) - 과금형 완속 충전기의 충전기 제어 보드 설계 및 제작
              - 과금형 완속 충전기의 충전기 임베디드 프로그램 구현
              - 개발 자료는 양산 제품의 5만대 납품(니즈로봇)후 제공함"
                />
            </div>

            <div className="flex j a w100 mb10">
                <div className="input_wrap" style={{ width: '32%' }}>
                    <h1 className="mb10 flex minititle a">
                        6.계약 금액
                        <button
                            type="button"
                            onClick={setDefaultPrice}
                            className="navibtn_hover ml10"
                            style={{
                                width: '28px',
                                height: '28px',
                                padding: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                            }}
                            title="견적 금액으로 변경"
                        >
                            ⟳
                        </button>
                    </h1>
                    <input
                        onChange={(e) => handleChanges('allprice', e.target.value)}
                        value={contract && contract.allprice}
                        className="projectAdd_inputbox"
                    />
                </div>

                <div className="input_wrap" style={{ width: '66%' }}>
                    <h1 className="mb10 flex minititle a">
                        7.입금 계좌번호
                        <button
                            type="button"
                            onClick={setDefaultBank}
                            className="navibtn_hover ml10"
                            style={{
                                width: '28px',
                                height: '28px',
                                padding: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                            }}
                            title="기본 계좌로 변경"
                        >
                            ⟳
                        </button>
                    </h1>

                    <div className="flex j a w100">
                        <div style={{ width: '22%', paddingRight: '10px' }}>
                            <input
                                value={(contract && contract.bankname) || ''}
                                onChange={(e) => handleChanges('bankname', e.target.value)}
                                className="projectAdd_inputbox"
                                placeholder="은행"
                            />
                        </div>

                        <div style={{ width: '23%', paddingRight: '10px' }}>
                            <input
                                value={(contract && contract.bankowner) || ''}
                                onChange={(e) => handleChanges('bankowner', e.target.value)}
                                className="projectAdd_inputbox"
                                placeholder="예금주"
                            />
                        </div>

                        <div style={{ width: '55%' }}>
                            <input
                                value={(contract && contract.bankaccount) || ''}
                                onChange={(e) => handleChanges('bankaccount', e.target.value)}
                                className="projectAdd_inputbox"
                                placeholder="계좌번호"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex j a w100 mb10">
                <div className="input_wrap w33">
                    <h1 className="mb10 flex minititle a">
                        8.선금
                        <p className="subtext ml10">계약금액의 %비율로 입력(0 ~ 100%) </p>
                    </h1>

                    <PercentInputWrap>
                        <PercentInput
                            value={(contract && contract.beforeprice) || ''}
                            onChange={(e) => handlePercentChange('beforeprice', e.target.value)}
                            type="number"
                            min="0"
                            max="100"
                            className="projectAdd_inputbox"
                        />
                        <PercentText>%</PercentText>
                    </PercentInputWrap>

                    <p className="custom-price">
                        {contract &&
                            contract.allprice &&
                            comma(
                                (Number(removeComma(contract && contract.allprice)) *
                                    Number((contract && contract.beforeprice) || 0)) /
                                    100,
                            )}{' '}
                        원
                    </p>

                    <div className="mt10">
                        <input
                            value={(contract && contract.beforepricecon) || BEFORE_TERM}
                            readOnly
                            className="projectAdd_inputbox"
                            style={{ backgroundColor: '#f8f8f8' }}
                        />
                    </div>
                </div>

                <div className="input_wrap w33">
                    <h1 className="mb10 flex minititle a">
                        9.중도금
                        <p className="subtext ml10">계약금액의 %비율로 입력(0 ~ 100%)</p>
                    </h1>

                    <PercentInputWrap>
                        <PercentInput
                            value={(contract && contract.middleprice) || ''}
                            onChange={(e) => handlePercentChange('middleprice', e.target.value)}
                            type="number"
                            min="0"
                            max="100"
                            className="projectAdd_inputbox"
                        />
                        <PercentText>%</PercentText>
                    </PercentInputWrap>

                    <p className="custom-price">
                        {contract &&
                            contract.allprice &&
                            comma(
                                (Number(removeComma(contract && contract.allprice)) *
                                    Number((contract && contract.middleprice) || 0)) /
                                    100,
                            )}{' '}
                        원
                    </p>

                    <div className="mt10">
                        <input
                            value={(contract && contract.middlepricecon) || MIDDLE_TERM}
                            readOnly
                            className="projectAdd_inputbox"
                            style={{ backgroundColor: '#f8f8f8' }}
                        />
                    </div>
                </div>

                <div className="input_wrap w33">
                    <h1 className="mb10 flex minititle a">
                        10.잔금
                        <p className="subtext ml10">계약금액의 %비율로 입력(0 ~ 100%)</p>
                    </h1>

                    <PercentInputWrap>
                        <PercentInput
                            value={(contract && contract.afterprice) || ''}
                            onChange={(e) => handlePercentChange('afterprice', e.target.value)}
                            type="number"
                            min="0"
                            max="100"
                            className="projectAdd_inputbox"
                        />
                        <PercentText>%</PercentText>
                    </PercentInputWrap>

                    <p className="custom-price">
                        {contract &&
                            contract.allprice &&
                            comma(
                                (Number(removeComma(contract.allprice)) *
                                    Number((contract && contract.afterprice) || 0)) /
                                    100,
                            )}{' '}
                        원
                    </p>

                    <div className="mt10">
                        <input
                            value={(contract && contract.afterpricecon) || AFTER_TERM}
                            readOnly
                            className="projectAdd_inputbox"
                            style={{ backgroundColor: '#f8f8f8' }}
                        />
                    </div>
                </div>
            </div>

            <div className="flex a">
                <label htmlFor="specificationFileInput" className="gbox_hover mr10">
                    사양서 첨부
                    <input
                        ref={specificationImgRef}
                        className="none"
                        id="specificationFileInput"
                        type="file"
                        accept="*"
                        onChange={(e) => {
                            handleChanges('newspecification', URL.createObjectURL(e.target.files[0]))
                            handleChanges('newspecificationname', e.target.files[0].name)
                        }}
                    />
                </label>

                {contract && contract ? (
                    <div className="mr10 file-container ">
                        {contract.newspecificationname
                            ? contract.newspecificationname
                            : contract.newspecification
                            ? contract.newspecification.split('/')[contract.newspecification.split('/').length - 1]
                            : contract.specificationname
                            ? contract.specificationname
                            : contract.specification
                            ? contract.specification.split('/')[contract.specification.split('/').length - 1]
                            : '파일을 첨부해 주세요'}
                    </div>
                ) : (
                    ''
                )}
            </div>
        </div>
    )
}

export default Project_contract

const PercentInputWrap = styled.div`
    position: relative;
    width: 100%;
`

const PercentInput = styled.input`
    padding-right: 34px !important;
`

const PercentText = styled.span`
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #666;
    font-size: 14px;
    font-weight: 700;
    pointer-events: none;
`
